/** Caption styling for Home screen tiles over background images. */
export const launcherHomeLabelSx = {
  color: '#fff',
  fontWeight: 600,
  textShadow:
    '-1px -1px 0 rgba(0, 0, 0, 0.9), 1px -1px 0 rgba(0, 0, 0, 0.9), -1px 1px 0 rgba(0, 0, 0, 0.9), 1px 1px 0 rgba(0, 0, 0, 0.9), 0 2px 4px rgba(0, 0, 0, 0.8)',
};

/** Layout-only props shared by all AppIcon captions (wrap/truncate unchanged). */
export const launcherIconLabelLayoutSx = {
  textAlign: 'center',
  px: 0.25,
  width: '100%',
  maxWidth: '100%',
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  overflowWrap: 'anywhere',
  lineHeight: 1.15,
  fontSize: 'clamp(0.62rem, 9.5cqmin, 0.8rem)',
  letterSpacing: 0,
};
